// extracted by mini-css-extract-plugin
module.exports = {"container":"products-taxon_container__QBNiA","title":"products-taxon_title__fWEvG","products":"products-taxon_products__LwXb2"};